<template>
  <div class="container">
      <!-- {{ surveys }} -->
      <!-- {{ totalSynced }} -->
      <div v-if="isOnline">
        <div v-for="survey in surveys" :key="survey.id" class="list">
            <a @click.prevent="syncSurvey(survey)" class="import-link">
                #{{ survey.id }} Click to synchronize data of {{ survey.name }}
                <span class="progress"></span>
            </a>
        </div>
        <div v-if="showMessage">
            <p>{{ totalSynced }}/{{ surveys.find(s => s.id === surveySelected).total }} surveys sync</p>
        </div>
      </div>
      <div v-else>{{ message }}</div>
  </div>
</template>

<script>
import axios from 'axios';
import {
    surveys as surveysDb,
    answers as answersDb,
    settings as settingsDb
} from '@/database';

export default {
    name: 'Sync',

    data() {
        return {
            surveys: [],
            surveySelected: null,
            settings: {},
            message: '',
            totalSynced: 0,
            showMessage: false,
        }
    },

    methods: {
        buildSurveys() {
            surveysDb.keys().then(keys => {
                keys.map((key) => {
                    surveysDb.getItem(key).then(item => {
                        this.surveys.push({
                            id: item.id,
                            name: item.name,
                            total: 0
                        })
                    })
                })
            });
            answersDb.keys().then((keys) => {
                keys.forEach((key) => {
                    answersDb.getItem(key).then((value) => {
                    const index = this.surveys.findIndex(s => s.id == value.survey);
                    if (index >= 0)
                        this.surveys[index].total++;
                    })
                })
            })
        },

        syncSurvey({id, name}) {
            if ( !this.isOnline ) {
                alert('It looks like you are not connected to internet');
                return;
            }

            if ( confirm(`You really want to sync answers of ${name} ?`) ){
                this.surveySelected = id;
                this.showMessage = true;
                answersDb.keys().then(keys => {
                    keys.map(key => {
                        answersDb.getItem(key).then(item => {
                            (async () => {
                                await axios.post(`${this.settings.apiEndpoint}sync/index.php`, {
                                    data: item
                                })
                                .then(response => {
                                    console.log(response.data);
                                    const data = response.data;
                                    if (data.status === 200){
                                        answersDb.removeItem(key);
                                        this.totalSynced++;
                                    }
                                })
                                .catch(error => {
                                    console.error(error);
                                })
                            })();
                        })
                    })

                    setTimeout(() => {
                        this.showMessage = false;
                    }, 4000)
                })
            }
        }
    },

    computed: {
        isOnline() {
            return this.$parent.online
        }
    },

    mounted() {
        this.buildSurveys();

        (async() => {
            this.settings.apiEndpoint = await settingsDb.getItem('api-endpoint');
            this.settings.username = await settingsDb.getItem('username');
            this.settings.password = await settingsDb.getItem('password');

            if ( this.settings.apiEndpoint == null ) {
                this.$router.push({ name: 'settings' });
                return;
            }

            if ( ! this.isOnline ) {
                this.message = 'It seems like you are not connected.';
                return;
            }
        })();
    }
}
</script>

<style lang="scss" scoped>
.list {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 500px;

    .import-link {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 1rem 0;
        padding: .5rem;
        width: 100%;
        height: 38px;
        color: black;
        font-size: 1.4rem;
        font-weight: 700;
        text-align: center;
        text-transform: uppercase;
        background-color: var(--primary);
        border: 1px solid #666;
        border-radius: 3px;
        cursor: pointer;

        &.active {
            background-color: var(--primary);
        }

        span.progress {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            height: 2px;
            background-color: var(--primary);
        }
    }
}
</style>